/** Median of a non-empty list of numbers. */
function median(values: number[]): number {
  const sorted = [...values].sort((a, b) => a - b)
  const mid = Math.floor(sorted.length / 2)
  return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2
}

/**
 * Price tier (1=$, 2=$$, 3=$$$) from a location's item prices (these are the
 * CARD prices). Thresholds are on the MEDIAN item price and are tunable per
 * market. Returns null when there are no priced items.
 */
export function priceTierFromPrices(prices: number[]): 1 | 2 | 3 | null {
  const valid = prices.filter((p) => typeof p === "number" && p > 0)
  if (valid.length === 0) return null
  const m = median(valid)
  if (m < 10) return 1
  if (m < 20) return 2
  return 3
}

/** "$" / "$$" / "$$$" from a tier; "" when null. */
export function priceTierLabel(tier: 1 | 2 | 3 | null): string {
  return tier ? "$".repeat(tier) : ""
}

/**
 * Format a 24h "HH:mm" clock string to a localized 12h label.
 * "22:30" → "10:30 PM", "09:00" → "9:00 AM", "00:15" → "12:15 AM".
 * Returns "" for null/invalid input.
 */
export function formatClock12h(hhmm: string | null): string {
  if (!hhmm) return ""
  const [hStr, mStr] = hhmm.split(":")
  const h = parseInt(hStr, 10)
  const m = parseInt(mStr, 10)
  if (Number.isNaN(h) || Number.isNaN(m)) return ""
  const period = h < 12 ? "AM" : "PM"
  const h12 = h % 12 === 0 ? 12 : h % 12
  return `${h12}:${m.toString().padStart(2, "0")} ${period}`
}
